// import React, {useState} from 'react';
// import { useNavigate } from 'react-router-dom';
// import { signOut, deleteUser } from 'firebase/auth'; // deleteUser 추가
// import { auth } from '../firebase-config';
// import { useAuth } from '../contexts/authContext';
// import { useSocket } from '../contexts/socketContext'; // 소켓 추가
// import { API_URL } from '../lib/config';
// import './SettingsPage.css'; // 아래 작성된 CSS 파일

// function SettingsPage() {
//     const navigate = useNavigate();
//     const { currentUser } = useAuth();
//     const socket = useSocket(); // 로그아웃 시 소켓 끊기 위해 필요
//     const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
//     const [feedbackContent, setFeedbackContent] = useState('');
//     const [isSending, setIsSending] = useState(false);

//     const handleLogout = async () => {
//         if (!window.confirm("정말 로그아웃 하시겠습니까?")) return;

//         try {
//             if (socket && socket.connected) {
//                 socket.emit('cancel_matching');
//                 socket.disconnect();
//             }
//             await signOut(auth);
//             navigate('/');
//         } catch (error) {
//             console.error("로그아웃 오류:", error);
//         }
//     };

//     // [프론트엔드] 구독 관리 버튼 클릭 핸들러
//     const handleManageSubscription = async () => {
//         try {
//             const idToken = await currentUser.getIdToken();
//             const response = await fetch(`${API_URL}/api/payment/customer-portal`, { // 백엔드 주소에 맞게 변경
//                 method: 'POST',
//                 headers: { 
//                     'Authorization': `Bearer ${idToken}`,
//                     'Content-Type': 'application/json' 
//                 }
//             });

//             const data = await response.json();

//             if (response.ok && data.url) {
//                 // 성공하면 Polar의 구독 관리 페이지로 휙! 이동시킵니다.
//                 window.location.href = data.url; 
//             } else {
//                 alert(data.message || '구독 관리 페이지를 열 수 없습니다.');
//             }
//         } catch (error) {
//             console.error("구독 관리 오류", error);
//             alert("일시적인 오류가 발생했습니다.");
//         }
//     };

//     const handleDeleteAccount = async () => {
//         if (!currentUser) return;
//         if (!window.confirm("정말로 회원 탈퇴를 진행하시겠습니까? 모든 데이터가 삭제됩니다.")) return;
        
//         const input = window.prompt("데이터를 삭제하려면 '회원탈퇴'라고 입력해주세요.");
//         if (input !== "회원탈퇴") return alert("입력이 일치하지 않습니다.");
    
//         try {
//             const idToken = await currentUser.getIdToken();
//             await fetch(`${API_URL}/api/login/delete-account`, {
//                 method: 'DELETE',
//                 headers: { 'Authorization': `Bearer ${idToken}` }
//             });
//             await deleteUser(currentUser);
//             alert("탈퇴가 완료되었습니다.");
//             navigate('/');
//         } catch (error) {
//             console.error(error);
//             alert("탈퇴 처리 중 오류가 발생했습니다.");
//         }
//     };

//     const handleSendFeedback = async () => {
//         if (!feedbackContent.trim()) {
//             alert("내용을 입력해주세요.");
//             return;
//         }

//         setIsSending(true);
//         try {
//             // 로그인 했으면 ID 포함, 아니면 null (백엔드에서 처리)
//             // 비회원이라도 보낼 수 있게 idToken 헤더는 생략하거나 선택적으로 보냄
//             const bodyData = {
//                 content: feedbackContent,
//                 userId: currentUser ? currentUser.uid : null 
//             };

//             const response = await fetch(`${API_URL}/api/feedback`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(bodyData)
//             });

//             const data = await response.json();

//             if (response.ok) {
//                 alert(data.message); // "소중한 의견 감사합니다!"
//                 setIsFeedbackOpen(false);
//                 setFeedbackContent('');
//             } else {
//                 alert(data.message); // "10분에 한 번만..." 또는 에러 메시지
//             }
//         } catch (error) {
//             console.error(error);
//             alert("전송 중 오류가 발생했습니다.");
//         } finally {
//             setIsSending(false);
//         }
//     };

//     return (
//         <div className="settings-page-container">
//             {/* 배경 별 애니메이션 (NoticePage와 동일) */}
//             <div id="bright-stars1"></div>
//             <div id="bright-stars2"></div>
//             <div id="bright-stars3"></div>

//             {/* 상단 바 */}
//             <div className="settings-top-bar">
//                 <button className="back-button-icon" onClick={() => navigate(-1)}>
//                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M15 19L8 12L15 5" stroke="#333333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//                     </svg>
//                 </button>
//                 <div className="top-bar-title">설정</div>
//             </div>

//             {/* 메인 콘텐츠 (메뉴 목록) */}
//             <main className="settings-main-content">
//                 <div className="settings-menu-list">
//                     {/* 내 정보 */}
//                     <button 
//                         className="settings-menu-item" 
//                         onClick={() => navigate('/settings/my-info')}
//                     >
//                         <span className="menu-label">내 정보</span>
//                         <span className="menu-arrow">›</span>
//                     </button>

//                     {/* 구분선 역할 (빈 공간 or border) */}
//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     {isPlus ? (
//                         <button onClick={handleManageSubscription} className="manage-sub-button">
//                             ✨ 구독 관리
//                         </button>
//                     ) : (
//                         <button onClick={() => navigate('/subscription')} className="subscribe-button">
//                             ✨ TAIM PLUS 구독하기
//                         </button>
//                     )}

//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     {/* 2. 서비스 정보 (약관 등) - a 태그 사용 */}
//                     {/* 스타일 통일을 위해 settings-menu-item 클래스 사용 + textDecoration 제거 */}
//                     <a 
//                         href="/terms" 
//                         target="_blank" 
//                         rel="noopener noreferrer" 
//                         className="settings-menu-item"
//                         style={{ textDecoration: 'none' }} 
//                     >
//                         <span className="menu-label">이용약관</span>
//                         <span className="menu-arrow">›</span>
//                     </a>

//                     <a 
//                         href="/policy" 
//                         target="_blank" 
//                         rel="noopener noreferrer" 
//                         className="settings-menu-item"
//                         style={{ textDecoration: 'none' }}
//                     >
//                         <span className="menu-label">개인정보처리방침</span>
//                         <span className="menu-arrow">›</span>
//                     </a>

//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     <button className="settings-menu-item" onClick={() => setIsFeedbackOpen(true)}>
//                         <span className="menu-label">서비스 의견 보내기</span>
//                         <span className="menu-arrow">✎</span>
//                     </button>

//                     {/* 구분선 역할 (빈 공간 or border) */}
//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     {/* 로그아웃 */}
//                     <button className="settings-menu-item" onClick={handleLogout}>
//                         <span className="menu-label">로그아웃</span>
//                     </button>

//                     {/* 회원 탈퇴 (붉은색 텍스트 스타일 적용) */}
//                     <button className="settings-menu-item" onClick={handleDeleteAccount}>
//                         <span className="menu-label" style={{ color: '#ff6b6b' }}>회원 탈퇴</span>
//                     </button>
//                 </div>
//             </main>

//             {isFeedbackOpen && (
//                 <div className="popup-overlay" onClick={() => setIsFeedbackOpen(false)}>
//                     <div className="popup" onClick={(e) => e.stopPropagation()} style={{ width: '90%', maxWidth: '400px' }}>
//                         <h3 style={{ marginBottom: '15px' }}>개발자에게 의견 보내기</h3>
                        
//                         {/* ▼▼▼ [수정] 부담을 낮춰주는 안내 문구 ▼▼▼ */}
//                         <div style={{ textAlign: 'left', fontSize: '13px', color: '#ccc', marginBottom: '15px', lineHeight: '1.6' }}>
//                             <p style={{ margin: '0 0 8px 0' }}>
//                                 안녕하세요! 1인 개발자 pickybeak입니다. 🧑‍💻<br/>
//                                 혼자 운영 중이라 개별 답변은 드리기 어렵지만,
//                                 보내주신 의견은 꼼꼼히 읽고 서비스 개선에 소중하게 활용하겠습니다.
//                             </p>
//                             <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>
//                                 * 계정 관련 급한 문제는 이메일로 문의주세요.
//                                 pickybeak@naver.com
//                             </p>
//                         </div>

//                         <textarea
//                             style={{
//                                 width: '100%',
//                                 height: '120px',
//                                 padding: '10px',
//                                 borderRadius: '8px',
//                                 border: '1px solid #555',
//                                 backgroundColor: '#333',
//                                 color: 'white',
//                                 resize: 'none',
//                                 boxSizing: 'border-box',
//                                 fontFamily: 'inherit'
//                             }}
//                             /* ▼▼▼ [수정] 플레이스홀더도 가볍게 변경 ▼▼▼ */
//                             placeholder="버그 제보, 응원, 바라는 점 등 자유롭게 남겨주세요!"
//                             value={feedbackContent}
//                             onChange={(e) => setFeedbackContent(e.target.value)}
//                             maxLength={1000}
//                         />
                        
//                         <div className="consent-buttons" style={{ marginTop: '20px' }}>
//                             <button onClick={handleSendFeedback} disabled={isSending}>
//                                 {isSending ? '전송 중...' : '보내기'}
//                             </button>
//                             <button className="cancel-button" onClick={() => setIsFeedbackOpen(false)}>
//                                 닫기
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { signOut, deleteUser } from 'firebase/auth';
// import { auth } from '../firebase-config';
// import { useAuth } from '../contexts/authContext';
// import { useSocket } from '../contexts/socketContext';
// import { API_URL } from '../lib/config';
// import './SettingsPage.css';

// function SettingsPage() {
//     const navigate = useNavigate();
//     const { currentUser } = useAuth();
//     const socket = useSocket();
//     const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
//     const [feedbackContent, setFeedbackContent] = useState('');
//     const [isSending, setIsSending] = useState(false);

//     // ⭐ 1. [추가] PLUS 여부를 저장할 state와 로딩 상태 추가
//     const [isPlus, setIsPlus] = useState(false);
//     const [isLoadingUser, setIsLoadingUser] = useState(true);

//     // ⭐ 2. [추가] 페이지 렌더링 시 유저 정보 불러와서 isPlus 판단하기
//     useEffect(() => {
//         if (!currentUser) return;
        
//         const fetchUserInfo = async () => {
//             try {
//                 const idToken = await currentUser.getIdToken();
//                 const response = await fetch(`${API_URL}/api/login/me`, {
//                     headers: { 'Authorization': `Bearer ${idToken}` }
//                 });
//                 const data = await response.json();
                
//                 if (response.ok && data.user) {
//                     // active 이거나 canceled인데 아직 만료일이 남은 경우 PLUS로 인정!
//                     const subStatus = data.user.subscriptionStatus;
//                     const periodEnd = new Date(data.user.currentPeriodEnd);
//                     const now = new Date();
                    
//                     if ((subStatus === 'active' || subStatus === 'canceled') && periodEnd > now) {
//                         setIsPlus(true);
//                     } else {
//                         setIsPlus(false);
//                     }
//                 }
//             } catch (error) {
//                 console.error("유저 정보 로딩 에러:", error);
//             } finally {
//                 setIsLoadingUser(false);
//             }
//         };

//         fetchUserInfo();
//     }, [currentUser]);


//     const handleLogout = async () => {
//         if (!window.confirm("정말 로그아웃 하시겠습니까?")) return;
//         try {
//             if (socket && socket.connected) {
//                 socket.emit('cancel_matching');
//                 socket.disconnect();
//             }
//             await signOut(auth);
//             navigate('/');
//         } catch (error) {
//             console.error("로그아웃 오류:", error);
//         }
//     };

//     // [프론트엔드] 구독 관리 버튼 클릭 핸들러
//     const handleManageSubscription = async () => {
//         try {
//             const idToken = await currentUser.getIdToken();
//             const response = await fetch(`${API_URL}/api/payment/customer-portal`, { 
//                 method: 'POST',
//                 headers: { 
//                     'Authorization': `Bearer ${idToken}`,
//                     'Content-Type': 'application/json' 
//                 }
//             });

//             const data = await response.json();

//             if (response.ok && data.url) {
//                 // 성공하면 Polar의 구독 관리 페이지로 휙! 이동시킵니다.
//                 window.location.href = data.url; 
//             } else {
//                 alert(data.message || '구독 관리 페이지를 열 수 없습니다.');
//             }
//         } catch (error) {
//             console.error("구독 관리 오류", error);
//             alert("일시적인 오류가 발생했습니다.");
//         }
//     };

//     const handleDeleteAccount = async () => {
//         if (!currentUser) return;
//         if (!window.confirm("정말로 회원 탈퇴를 진행하시겠습니까? 모든 데이터가 삭제됩니다.")) return;
        
//         const input = window.prompt("데이터를 삭제하려면 '회원탈퇴'라고 입력해주세요.");
//         if (input !== "회원탈퇴") return alert("입력이 일치하지 않습니다.");
    
//         try {
//             const idToken = await currentUser.getIdToken();
//             await fetch(`${API_URL}/api/login/delete-account`, {
//                 method: 'DELETE',
//                 headers: { 'Authorization': `Bearer ${idToken}` }
//             });
//             await deleteUser(currentUser);
//             alert("탈퇴가 완료되었습니다.");
//             navigate('/');
//         } catch (error) {
//             console.error(error);
//             alert("탈퇴 처리 중 오류가 발생했습니다.");
//         }
//     };

//     const handleSendFeedback = async () => {
//         if (!feedbackContent.trim()) {
//             alert("내용을 입력해주세요.");
//             return;
//         }

//         setIsSending(true);
//         try {
//             const bodyData = {
//                 content: feedbackContent,
//                 userId: currentUser ? currentUser.uid : null 
//             };

//             const response = await fetch(`${API_URL}/api/feedback`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(bodyData)
//             });

//             const data = await response.json();

//             if (response.ok) {
//                 alert(data.message); 
//                 setIsFeedbackOpen(false);
//                 setFeedbackContent('');
//             } else {
//                 alert(data.message); 
//             }
//         } catch (error) {
//             console.error(error);
//             alert("전송 중 오류가 발생했습니다.");
//         } finally {
//             setIsSending(false);
//         }
//     };

//     return (
//         <div className="settings-page-container">
//             <div id="bright-stars1"></div>
//             <div id="bright-stars2"></div>
//             <div id="bright-stars3"></div>

//             <div className="settings-top-bar">
//                 <button className="back-button-icon" onClick={() => navigate(-1)}>
//                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M15 19L8 12L15 5" stroke="#333333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//                     </svg>
//                 </button>
//                 <div className="top-bar-title">설정</div>
//             </div>

//             <main className="settings-main-content">
//                 <div className="settings-menu-list">
                    
//                     <button className="settings-menu-item" onClick={() => navigate('/settings/my-info')}>
//                         <span className="menu-label">내 정보</span>
//                         <span className="menu-arrow">›</span>
//                     </button>

//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     {/* ⭐ 3. [수정] isPlus 상태에 따라 기존의 예쁜 스타일을 유지한 채 텍스트와 클릭 로직만 바꿉니다. ⭐ */}
//                     {!isLoadingUser && (
//                         <button 
//                             className="settings-menu-item" 
//                             onClick={isPlus ? handleManageSubscription : () => navigate('/subscription')} 
//                             style={{ 
//                                 backgroundColor: 'rgba(255, 215, 0, 0.1)', // 골드빛 배경 유지!
//                                 borderRadius: '8px', 
//                                 padding: '12px 15px' 
//                             }} 
//                         >
//                             <span className="menu-label" style={{ fontWeight: 'bold', color: '#000000' }}>
//                                 {isPlus ? '✨ 구독 관리 (취소/변경)' : '✨ TAIM PLUS 구독하기'}
//                             </span>
//                             <span className="menu-arrow" style={{ color: '#FFD700' }}>›</span>
//                         </button>
//                     )}

//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     <a href="/terms" target="_blank" rel="noopener noreferrer" className="settings-menu-item" style={{ textDecoration: 'none' }}>
//                         <span className="menu-label">이용약관</span>
//                         <span className="menu-arrow">›</span>
//                     </a>

//                     <a href="/policy" target="_blank" rel="noopener noreferrer" className="settings-menu-item" style={{ textDecoration: 'none' }}>
//                         <span className="menu-label">개인정보처리방침</span>
//                         <span className="menu-arrow">›</span>
//                     </a>

//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     <button className="settings-menu-item" onClick={() => setIsFeedbackOpen(true)}>
//                         <span className="menu-label">서비스 의견 보내기</span>
//                         <span className="menu-arrow">✎</span>
//                     </button>

//                     <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

//                     <button className="settings-menu-item" onClick={handleLogout}>
//                         <span className="menu-label">로그아웃</span>
//                     </button>

//                     <button className="settings-menu-item" onClick={handleDeleteAccount}>
//                         <span className="menu-label" style={{ color: '#ff6b6b' }}>회원 탈퇴</span>
//                     </button>
//                 </div>
//             </main>

//             {isFeedbackOpen && (
//                 {/* 팝업 UI 생략 (기존과 동일) */}
//             )}
//         </div>
//     );
// }

// export default SettingsPage;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut, deleteUser } from 'firebase/auth';
import { auth } from '../firebase-config';
import { useAuth } from '../contexts/authContext';
import { useSocket } from '../contexts/socketContext';
import { API_URL } from '../lib/config';
import './SettingsPage.css';

function SettingsPage() {
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const socket = useSocket();
    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
    const [feedbackContent, setFeedbackContent] = useState('');
    const [isSending, setIsSending] = useState(false);

    // ⭐ 1. PLUS 여부를 저장할 state와 로딩 상태 추가
    const [isPlus, setIsPlus] = useState(false);
    const [isLoadingUser, setIsLoadingUser] = useState(true);

    // ⭐ 2. 페이지 렌더링 시 유저 정보 불러와서 isPlus 판단하기
    useEffect(() => {
        if (!currentUser) return;
        
        const fetchUserInfo = async () => {
            try {
                const idToken = await currentUser.getIdToken();
                const response = await fetch(`${API_URL}/api/login/me`, {
                    headers: { 'Authorization': `Bearer ${idToken}` }
                });
                const data = await response.json();
                
                if (response.ok && data.user) {
                    // active 이거나 canceled인데 아직 만료일이 남은 경우 PLUS로 인정!
                    const subStatus = data.user.subscriptionStatus;
                    const periodEnd = new Date(data.user.currentPeriodEnd);
                    const now = new Date();
                    
                    if ((subStatus === 'active' || subStatus === 'canceled') && periodEnd > now) {
                        setIsPlus(true);
                    } else {
                        setIsPlus(false);
                    }
                }
            } catch (error) {
                console.error("유저 정보 로딩 에러:", error);
            } finally {
                setIsLoadingUser(false);
            }
        };

        fetchUserInfo();
    }, [currentUser]);

    const handleLogout = async () => {
        if (!window.confirm("정말 로그아웃 하시겠습니까?")) return;
        try {
            if (socket && socket.connected) {
                socket.emit('cancel_matching');
                socket.disconnect();
            }
            await signOut(auth);
            navigate('/');
        } catch (error) {
            console.error("로그아웃 오류:", error);
        }
    };

    const handleManageSubscription = async () => {
        try {
            const idToken = await currentUser.getIdToken();
            const response = await fetch(`${API_URL}/api/payment/customer-portal`, { 
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${idToken}`,
                    'Content-Type': 'application/json' 
                }
            });

            const data = await response.json();

            if (response.ok && data.url) {
                window.location.href = data.url; 
            } else {
                alert(data.message || '구독 관리 페이지를 열 수 없습니다.');
            }
        } catch (error) {
            console.error("구독 관리 오류", error);
            alert("일시적인 오류가 발생했습니다.");
        }
    };

    const handleDeleteAccount = async () => {
        if (!currentUser) return;
        if (!window.confirm("정말로 회원 탈퇴를 진행하시겠습니까? 모든 데이터가 삭제됩니다.")) return;
        
        const input = window.prompt("데이터를 삭제하려면 '회원탈퇴'라고 입력해주세요.");
        if (input !== "회원탈퇴") return alert("입력이 일치하지 않습니다.");
    
        try {
            const idToken = await currentUser.getIdToken();
            await fetch(`${API_URL}/api/login/delete-account`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${idToken}` }
            });
            await deleteUser(currentUser);
            alert("탈퇴가 완료되었습니다.");
            navigate('/');
        } catch (error) {
            console.error(error);
            alert("탈퇴 처리 중 오류가 발생했습니다.");
        }
    };

    const handleSendFeedback = async () => {
        if (!feedbackContent.trim()) {
            alert("내용을 입력해주세요.");
            return;
        }

        setIsSending(true);
        try {
            const bodyData = {
                content: feedbackContent,
                userId: currentUser ? currentUser.uid : null 
            };

            const response = await fetch(`${API_URL}/api/feedback`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData)
            });

            const data = await response.json();

            if (response.ok) {
                alert(data.message); 
                setIsFeedbackOpen(false);
                setFeedbackContent('');
            } else {
                alert(data.message); 
            }
        } catch (error) {
            console.error(error);
            alert("전송 중 오류가 발생했습니다.");
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="settings-page-container">
            <div id="bright-stars1"></div>
            <div id="bright-stars2"></div>
            <div id="bright-stars3"></div>

            <div className="settings-top-bar">
                <button className="back-button-icon" onClick={() => navigate(-1)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 19L8 12L15 5" stroke="#333333" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <div className="top-bar-title">설정</div>
            </div>

            <main className="settings-main-content">
                <div className="settings-menu-list">
                    
                    <button className="settings-menu-item" onClick={() => navigate('/settings/my-info')}>
                        <span className="menu-label">내 정보</span>
                        <span className="menu-arrow">›</span>
                    </button>

                    <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

                    {/* ⭐ 3. isPlus 상태에 따라 기존의 예쁜 스타일을 유지한 채 텍스트와 클릭 로직만 바꿉니다. */}
                    {!isLoadingUser && (
                        <button 
                            className="settings-menu-item" 
                            onClick={isPlus ? handleManageSubscription : () => navigate('/subscription')} 
                            style={{ 
                                backgroundColor: 'rgba(255, 215, 0, 0.1)',
                                borderRadius: '8px', 
                                padding: '12px 15px' 
                            }} 
                        >
                            <span className="menu-label" style={{ fontWeight: 'bold', color: '#000000' }}>
                                {isPlus ? '✨ 구독 관리 (취소/변경)' : '✨ TAIM PLUS 구독하기'}
                            </span>
                            <span className="menu-arrow" style={{ color: '#FFD700' }}>›</span>
                        </button>
                    )}

                    <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

                    <a href="/terms" target="_blank" rel="noopener noreferrer" className="settings-menu-item" style={{ textDecoration: 'none' }}>
                        <span className="menu-label">이용약관</span>
                        <span className="menu-arrow">›</span>
                    </a>

                    <a href="/policy" target="_blank" rel="noopener noreferrer" className="settings-menu-item" style={{ textDecoration: 'none' }}>
                        <span className="menu-label">개인정보처리방침</span>
                        <span className="menu-arrow">›</span>
                    </a>

                    <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

                    <button className="settings-menu-item" onClick={() => setIsFeedbackOpen(true)}>
                        <span className="menu-label">서비스 의견 보내기</span>
                        <span className="menu-arrow">✎</span>
                    </button>

                    <div style={{ height: '1px', backgroundColor: 'rgba(0,0,0,0.1)', margin: '10px 0' }}></div>

                    <button className="settings-menu-item" onClick={handleLogout}>
                        <span className="menu-label">로그아웃</span>
                    </button>

                    <button className="settings-menu-item" onClick={handleDeleteAccount}>
                        <span className="menu-label" style={{ color: '#ff6b6b' }}>회원 탈퇴</span>
                    </button>
                </div>
            </main>

            {/* 날아갔던 피드백 팝업창 UI 완벽 복구! 여기서 isSending과 handleSendFeedback이 쓰입니다. */}
            {isFeedbackOpen && (
                <div className="popup-overlay" onClick={() => setIsFeedbackOpen(false)}>
                    <div className="popup" onClick={(e) => e.stopPropagation()} style={{ width: '90%', maxWidth: '400px' }}>
                        <h3 style={{ marginBottom: '15px' }}>개발자에게 의견 보내기</h3>
                        
                        <div style={{ textAlign: 'left', fontSize: '13px', color: '#ccc', marginBottom: '15px', lineHeight: '1.6' }}>
                            <p style={{ margin: '0 0 8px 0' }}>
                                안녕하세요! 1인 개발자 pickybeak입니다. 🧑‍💻<br/>
                                혼자 운영 중이라 개별 답변은 드리기 어렵지만,
                                보내주신 의견은 꼼꼼히 읽고 서비스 개선에 소중하게 활용하겠습니다.
                            </p>
                            <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>
                                * 계정 관련 급한 문제는 이메일로 문의주세요.
                                pickybeak@naver.com
                            </p>
                        </div>

                        <textarea
                            style={{
                                width: '100%',
                                height: '120px',
                                padding: '10px',
                                borderRadius: '8px',
                                border: '1px solid #555',
                                backgroundColor: '#333',
                                color: 'white',
                                resize: 'none',
                                boxSizing: 'border-box',
                                fontFamily: 'inherit'
                            }}
                            placeholder="버그 제보, 응원, 바라는 점 등 자유롭게 남겨주세요!"
                            value={feedbackContent}
                            onChange={(e) => setFeedbackContent(e.target.value)}
                            maxLength={1000}
                        />
                        
                        <div className="consent-buttons" style={{ marginTop: '20px' }}>
                            <button onClick={handleSendFeedback} disabled={isSending}>
                                {isSending ? '전송 중...' : '보내기'}
                            </button>
                            <button className="cancel-button" onClick={() => setIsFeedbackOpen(false)}>
                                닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SettingsPage;